// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2QUzF","tableLoading":"Table_tableLoading__1G9c1","table":"Table_table__3ewj0"};